module.exports = __webpack_public_path__ + "static/img/NSW-33.7fa3c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-33.jpg
// module id = 8qdG
// module chunks = 0